import React, {useEffect} from 'react';

import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';

import {styles} from './form-select-picker.styles';
import {FormSelectPickerProps} from './form-select-picker.types';
import {useFormikContext, useField} from 'formik';

export const FormSelectPicker: React.FC<FormSelectPickerProps> = (
  props: any,
) => {
  const classes = styles();

  const {setFieldValue} = useFormikContext();
  const [field, meta] = useField(props.name);
  const errorText = meta.error && meta.touched ? meta.error : '';

  useEffect(() => {
    if (!field.value) {
      setFieldValue(props.name, 1);
    }
  }, [field.value, setFieldValue, props.name]);

  return (
    <FormControl className={classes.formControl}>
      <InputLabel htmlFor='type-simple'>{props.label}</InputLabel>
      <Select
        value={field.value ?? 1}
        onChange={(e: any) => {
          if (props.onChange) {
            props.onChange(e.target.value);
          }
          setFieldValue(props.name, e.target.value);
        }}
        name={props.name}>
        {props.items.map((itemType: any) => {
          return (
            <MenuItem key={props.name + itemType.id} value={itemType.id}>
              {itemType.name}
            </MenuItem>
          );
        })}
      </Select>
      <FormHelperText error={errorText ? true : false}>
        {errorText}
      </FormHelperText>
    </FormControl>
  );
};
